import React from "react";
import { string, number, array, func, bool, object } from "prop-types";
import { LoadMoreCollectionStories } from "@quintype/components";

import FiveStories1AdWithWidget from "../FiveStories1AdWithWidget";
import Stories2AdWithLoadMore from "../Stories2AdWithLoadMore";
import { DfpComponent } from "../../ads/dfp-component";
import DfpContainer from "../../ads/dfp-container";

import { getSlotId } from "../../utils/utils";

import "./sixteen-stories-3ad-with-tag-search-and-loadmore.m.css";

const NO_OF_STORIES_TO_LOAD = 10;

const SixteenStories3AdWithTagSearchAndLoadMore = ({ collectionSlug, stories, widgetUrl, lang, section }) => {
  const list = stories.map((story) => story);
  const firstStoriesSet = list.slice(0, 5);
  const remainingStoriesSet = list.map(({ story }) => story).slice(0, 20);
  const adType = lang === "en" ? "EnPalo_ROS_468x60_B1" : "News_468x60_B1";

  if (list.length < 0) return null;

  return (
    <div styleName="base">
      <FiveStories1AdWithWidget
        firstStoriesSet={firstStoriesSet}
        collectionSlug={collectionSlug}
        widgetUrl={widgetUrl}
        section={section}
      />
      <DfpContainer>
        <div styleName="middle-ad" className="adsBox">
          <DfpComponent
            type={adType}
            slotId={getSlotId(adType, collectionSlug, "sixteenStories3ad")}
            collectionSlug={collectionSlug}
            adsText={true}
          />
        </div>
      </DfpContainer>
      {stories.length > 5 && (
        <LoadMoreCollectionStories
          collectionSlug={collectionSlug}
          template={MoreCollectionStories}
          data={{ stories: remainingStoriesSet }} // passing all the stories and set offSet=16 , since first 16 stories are passed to two components
          numStoriesToLoad={NO_OF_STORIES_TO_LOAD}
        />
      )}
    </div>
  );
};

const MoreCollectionStories = ({ stories, onLoadMore, loading, noMoreStories }) => (
  <Stories2AdWithLoadMore
    list={stories.slice(5, stories.length)} // sliced first 6 stories for the first component and display next 10 stories initally to second component
    loading={loading}
    onLoadMore={onLoadMore}
    isMoreStories={NO_OF_STORIES_TO_LOAD < stories.slice(5, stories.length).length && !noMoreStories}
    className="loadmore-stories"
  />
);

SixteenStories3AdWithTagSearchAndLoadMore.propTypes = {
  accentColor: string,
  numberOfCardsInViewDesktop: number,
  numberOfCardsInViewTablet: number,
  numberOfCardsInViewMobile: number,
  stories: array,
  collectionSlug: string,
  widgetUrl: string,
  lang: string,
  section: object,
};

MoreCollectionStories.propTypes = {
  stories: array.isRequired,
  onLoadMore: func,
  noMoreStories: number,
  loading: bool,
};

SixteenStories3AdWithTagSearchAndLoadMore.storyLimit = 15;

export default SixteenStories3AdWithTagSearchAndLoadMore;
